import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';

import * as placesActions from '../actions/search-bar.actions';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';
import { PassengerArrangementState } from '@shared/base-search-bar/entities/passenger-arrangement-state';

export const passengerArrangementAdapter: EntityAdapter<PassengerArrangement> = createEntityAdapter<PassengerArrangement>();
export const initialPassengerArrangementState: PassengerArrangementState = passengerArrangementAdapter.getInitialState({
  ids: ['ADULTS', 'CHILDREN', 'INFANTS'],
  entities: {
    ADULTS: {
      id: 'ADULTS',
      quantity: 1
    },
    CHILDREN: {
      id: 'CHILDREN',
      quantity: 0
    },
    INFANTS: {
      id: 'INFANTS',
      quantity: 0
    }
  }
});

const reducer = createReducer(
  initialPassengerArrangementState,
  on(placesActions.selectPassengerArrangementAction, (state, { passengerArrangement }) => {
    const { id } = passengerArrangement;
    return passengerArrangementAdapter.updateOne(
      {
        id,
        changes: passengerArrangement
      },
      state
    );
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => {
    return data ? data.passengerArrangementsState : initialPassengerArrangementState;
  })
);

export function passengerArrangementReducer(state: PassengerArrangementState, action: Action): PassengerArrangementState {
  return reducer(state, action);
}
